import { isReplayEnabled } from './isEnabled'

export default isReplayEnabled
